import React, { useState, useEffect, useRef } from "react";
import refreshLogo from "../img/refreshLogo.svg";
import Expand_down from "../img/Expand_down.svg";
import Add_round from "../img/Add_round.svg";
import ArrowTop from "../img/ArrowTop.svg";
import ArrowBottom from "../img/ArrowBottom.svg";
import api from "../../api/axiosInstance";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Add_roundWhite from "../img/Add_roundWhite.svg";

const CreateLicense = () => {
  const navigate = useNavigate();
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [projects, setProjects] = useState([]);
  const [licenseLimits, setLicenseLimits] = useState([]);
  const [description, setDescription] = useState("");
  const [projectId, setProjectId] = useState("");
  const [paymentGateway, setPaymentGateway] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [durations, setDurations] = useState([]);
  const [slabPeriodChoices, setSlabPeriodChoices] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [projectPage, setProjectPage] = useState(1);
  const [hasMoreProjects, setHasMoreProjects] = useState(true);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);
  const dropdownRef = useRef(null);

  const [plans, setPlans] = useState([
    {
      planName: "",
      plandescription: "",
      limitCounts: [],
      licenseFeature: [{ feature: "" }],
      addedDurations: [{ duration: "", price: "" }],
      selectedDuration: "",
      selectedTopUps: [""],
      topUpPrices: [""],
      slabInputs: [{ periodCount: "", productCount: "", percentage: "" }],
      selectedSlabPeriod: "",
      slabPercentage: "",
      slabCount: "",
      slabPeriodCount: "",
      isSlabAvailableForAll: false,
      validationErrors: {},
      durationDropdownOpenList: [false],
      topUpDropdownOpenList: [false],
    },
  ]);

  const fetchProjectTypes = async (page = 1) => {
    if (isLoadingProjects || !hasMoreProjects) return;

    try {
      setIsLoadingProjects(true);
      const token = localStorage.getItem("accessToken");

      const res = await api.get(`/admin-app/api/v1/list-project?page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const newProjects = res.data?.data?.results || [];

      setProjects((prev) => [...prev, ...newProjects]);
      setHasMoreProjects(!!res.data?.data?.next);
      setSlabPeriodChoices(res.data.slab_period_choices || []);
      setProjectPage(page + 1);
    } catch (err) {
      console.error("Error fetching project types:", err);
    } finally {
      setIsLoadingProjects(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchProjectTypes();
    fetchDurations();
  }, []);

  const handleProjectTypeChange = (projectName) => {
    setSelectedProjectName(projectName);
    setDropdownOpen(false);

    const selectedProject = projects.find(
      (project) => project.name === projectName
    );
    if (selectedProject) {
      setPlans(
        plans.map((plan) => ({
          ...plan,
          limitCounts: selectedProject.license_limits.reduce((acc, limit) => {
            acc[limit] = "";
            return acc;
          }, {}),
        }))
      );
      setProjectId(selectedProject.id || "");
      setDescription(selectedProject.description || "");
      setLicenseLimits(selectedProject.license_limits || []);
      setPaymentGateway(selectedProject.is_payment_gateway_available || []);
    }
  };

  // 2. Update the handleCountChange function
  const handleCountChange = (planIndex, limit, value) => {
    const updatedPlans = [...plans];

    // Update the limitCounts object directly
    updatedPlans[planIndex].limitCounts = {
      ...updatedPlans[planIndex].limitCounts,
      [limit]: value,
    };

    // Clear validation error if it exists
    if (updatedPlans[planIndex].validationErrors?.[limit]) {
      delete updatedPlans[planIndex].validationErrors[limit];
    }

    setPlans(updatedPlans);
  };

  const validateTopUpType = (planIndex, topUpIndex, value) => {
    const errors = { ...plans[planIndex].validationErrors };
    const errorKey = `topUpType_${topUpIndex}`;

    delete errors[errorKey];

    if (!value || value.trim() === "") {
      errors[errorKey] = "Top-up type is required.";
    }

    const updatedPlans = [...plans];
    updatedPlans[planIndex].validationErrors = errors;
    setPlans(updatedPlans);
  };

  const validateTopUpPrice = (planIndex, topUpIndex, value) => {
    const errors = { ...plans[planIndex].validationErrors };
    const topUpType = plans[planIndex].selectedTopUps[topUpIndex];
    const errorKey = `topUpPrice_${topUpIndex}`;

    delete errors[errorKey];

    if (topUpType && topUpType.trim() !== "") {
      if (value === undefined || value === null || value === "") {
        errors[errorKey] = "Top-up price is required.";
      } else if (isNaN(value) || Number(value) < 0) {
        errors[errorKey] = "Top-up price must be a positive number.";
      }
    }

    const updatedPlans = [...plans];
    updatedPlans[planIndex].validationErrors = errors;
    setPlans(updatedPlans);
  };

  const validateForm = (planIndex) => {
    const currentPlan = plans[planIndex];
    const errors = {};
    let isValid = true;
    let firstErrorMessage = ""; // 🔹 Collect first error message

    if (!currentPlan) {
      return { isValid: false, message: "Invalid plan data" };
    }
    if (!selectedProjectName) {
      return { isValid: false, message: "Select the Application" };
    }

    // 3. Update the validation logic in validateForm
// Replace the licenseLimits validation section with:
if (licenseLimits && licenseLimits.length > 0) {
  licenseLimits.forEach((limit) => {
    const value = currentPlan.limitCounts?.[limit];

    if (value === undefined || value === null || value === "") {
      errors[limit] = "This field is required.";
      if (!firstErrorMessage)
        firstErrorMessage = `Limit Details is required.`;
      isValid = false;
    } else if (isNaN(value) || Number(value) < 0) {
      errors[limit] = "Must be a positive number.";
      if (!firstErrorMessage)
        firstErrorMessage = `${limit} must be a positive number.`;
      isValid = false;
    }
  });
}

    if (!currentPlan.planName?.trim()) {
      errors.planName = "Plan Name is required.";
      if (!firstErrorMessage) firstErrorMessage = "Plan Name is required.";
      isValid = false;
    }

    if (!currentPlan.plandescription?.trim()) {
      errors.plandescription = "Plan Description is required.";
      if (!firstErrorMessage)
        firstErrorMessage = "Plan Description is required.";
      isValid = false;
    }

    if (
      !currentPlan.licenseFeature ||
      currentPlan.licenseFeature.length === 0 ||
      currentPlan.licenseFeature.some((f) => !f?.feature?.trim())
    ) {
      errors.licenseFeature = "At least one feature is required.";
      if (!firstErrorMessage)
        firstErrorMessage = "At least one Plan feature is required.";
      isValid = false;
    }

    // if (
    //   !currentPlan.addedDurations ||
    //   currentPlan.addedDurations.length === 0 ||
    //   currentPlan.addedDurations.some((d) => !d?.duration || !d?.price)
    // ) {
    //   errors.durations = "At least one duration with price is required";
    //   if (!firstErrorMessage)
    //     firstErrorMessage = "Duration and price are required.";
    //   isValid = false;
    // }

    if (
      !currentPlan.addedDurations ||
      currentPlan.addedDurations.length === 0
    ) {
      errors.durations = "At least one duration is required";
      if (!firstErrorMessage)
        firstErrorMessage = "At least one duration is required.";
      isValid = false;
    } else {
      // Validate each duration individually
      currentPlan.addedDurations.forEach((durationItem, index) => {
        // Duration validation
        if (!durationItem.duration || !durationItem.duration.id) {
          errors[`duration_${index}`] = "Duration is required.";
          if (!firstErrorMessage) firstErrorMessage = "Duration is required.";
          isValid = false;
        }

        // Duration price validation (separate)
        if (
          durationItem.price === undefined ||
          durationItem.price === null ||
          durationItem.price === ""
        ) {
          errors[`durationPrice_${index}`] = "Duration price is required.";
          if (!firstErrorMessage)
            firstErrorMessage = "Duration price is required.";
          isValid = false;
        } else if (
          isNaN(durationItem.price) ||
          Number(durationItem.price) < 0
        ) {
          errors[`durationPrice_${index}`] =
            "Duration price must be a positive number.";
          if (!firstErrorMessage)
            firstErrorMessage = "Duration price must be a positive number.";
          isValid = false;
        }
      });
    }

    if (currentPlan.selectedTopUps && currentPlan.selectedTopUps.length > 0) {
      currentPlan.selectedTopUps.forEach((topUpType, index) => {
        const topUpPrice = currentPlan.topUpPrices[index];

        if (!topUpType || topUpType.trim() === "") {
          errors[`topUpType_${index}`] = "Top-up type is required.";
          if (!firstErrorMessage)
            firstErrorMessage = "Top-up type is required.";
          isValid = false;
        } else {
          if (
            topUpPrice === undefined ||
            topUpPrice === null ||
            topUpPrice === ""
          ) {
            errors[`topUpPrice_${index}`] = "Top-up price is required.";
            if (!firstErrorMessage)
              firstErrorMessage = "Top-up price is required.";
            isValid = false;
          } else if (isNaN(topUpPrice) || Number(topUpPrice) < 0) {
            errors[`topUpPrice_${index}`] =
              "Top-up price must be a positive number.";
            if (!firstErrorMessage)
              firstErrorMessage = "Top-up price must be a positive number.";
            isValid = false;
          }
        }
      });
    }

    const updatedPlans = [...plans];
    updatedPlans[planIndex].validationErrors = errors;
    setPlans(updatedPlans);

    return { isValid, message: firstErrorMessage };
  };

  const handleAddPlan = () => {
    const lastPlan = plans[plans.length - 1];

    setPlans([
      ...plans,
      {
        planName: "",
        plandescription: "",
        limitCounts: licenseLimits.map((limit) => ({ [limit]: "" })),
        licenseFeature: [{ feature: "" }],
        addedDurations: [{ duration: "", price: "" }],
        selectedDuration: "",
        selectedTopUps: [""],
        topUpPrices: [""],
        slabInputs:
          lastPlan?.slabInputs?.length > 0
            ? lastPlan.slabInputs.map((slab) => ({ ...slab })) // deep copy
            : [{ periodCount: "", productCount: "", percentage: "" }],

        selectedSlabPeriod: lastPlan?.selectedSlabPeriod || "",
        slabPercentage: lastPlan?.slabPercentage || "",
        slabCount: lastPlan?.slabCount || "",
        slabPeriodCount: "",
        isSlabAvailableForAll: lastPlan?.isSlabAvailableForAll || false,
        validationErrors: {},
        durationDropdownOpenList: [false],
        topUpDropdownOpenList: [false],
      },
    ]);
  };

  const handleSaveAllPlans = async () => {
    const token = localStorage.getItem("accessToken");

    // Validate all plans first
    let firstValidationError = "";

    const allValid = plans.every((_, idx) => {
      const result = validateForm(idx);
      if (!result.isValid && !firstValidationError) {
        firstValidationError = result.message;
      }
      return result.isValid;
    });

    if (!allValid) {
      setApiMessage(
        firstValidationError || "Please fill all required fields correctly"
      );
      setShowErrorModal(true);
      return;
    }

    const licenseDetails = plans.map((plan) => ({
      name: plan.planName,
      description: plan.plandescription,
      slab_period: plan.selectedSlabPeriod,
      slab_percentage: Number(plan.slabInputs[0]?.percentage) || 0,
      slab_count: Number(plan.slabInputs[0]?.productCount) || 0,
      slab_period_count: Number(plan.slabInputs[0]?.periodCount) || 0,
      is_slab_available_for_all: plan.isSlabAvailableForAll,
      limits_in_count: plan.limitCounts,
      license_features: plan.licenseFeature.map((feature) => ({
        feature: feature.feature,
      })),
      top_up_data: plan.topUpPrices.map((topUp, index) => ({
        top_up_type: plan.selectedTopUps[index],
        top_up_name: plan.selectedTopUps[index],
        top_up_price: Number(topUp) || 0,
      })),
      duration: plan.addedDurations.map((duration) => ({
        duration_master_id: duration.duration.id,
        price: Number(duration.price) || 0,
      })),
    }));

    const requestBody = {
      project_id: projectId,
      license_details: licenseDetails,
    };

    try {
      const response = await api.post(
        "/admin-app/api/v1/create-license",
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === "success") {
        setApiMessage(response.data.data || "License created successfully!");
        setShowSuccessModal(true);

        setPlans([
          {
            planName: "",
            plandescription: "",
            limitCounts: licenseLimits.map((limit) => ({ [limit]: "" })),
            licenseFeature: [{ feature: "" }],
            addedDurations: [{ duration: "", price: "" }],
            selectedDuration: "",
            selectedTopUps: [""],
            topUpPrices: [""],
            slabInputs: [{ periodCount: "", productCount: "", percentage: "" }],
            selectedSlabPeriod: "",
            slabPercentage: "",
            slabCount: "",
            slabPeriodCount: "",
            isSlabAvailableForAll: false,
            validationErrors: {},
            durationDropdownOpenList: [false],
            topUpDropdownOpenList: [false],
          },
        ]);
        setSelectedProjectName("");
        setProjectId("");
        setDescription("");
        setPaymentGateway(null);

        // Optionally clear all plans here if needed
      } else {
        setApiMessage(
          response.data.message || "Error during license creation."
        );
        setShowErrorModal(true);
      }
    } catch (error) {
      console.error("Error creating license:", error);
      setApiMessage("Error occurred while creating the license.");
      setShowErrorModal(true);
    }
  };

  const fetchDurations = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get("/admin-app/api/v1/list-duration", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const durationData = res.data?.data?.results || [];
      setDurations(durationData);
    } catch (err) {
      console.error("Error fetching durations:", err);
    }
  };

  const toggleDurationDropdown = (planIndex, durationIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].durationDropdownOpenList[durationIndex] =
      !updatedPlans[planIndex].durationDropdownOpenList[durationIndex];
    setPlans(updatedPlans);
  };

  const handleDurationSelect = (planIndex, durationIndex, selectedDuration) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].addedDurations[durationIndex].duration =
      selectedDuration; // Store full object
    updatedPlans[planIndex].durationDropdownOpenList[durationIndex] = false;
    setPlans(updatedPlans);
  };

  const handlePriceChange = (planIndex, durationIndex, value) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].addedDurations[durationIndex].price = value;
    setPlans(updatedPlans);
  };

  const handleAddDuration = (planIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].addedDurations.push({ duration: "", price: "" });
    updatedPlans[planIndex].durationDropdownOpenList.push(false);
    setPlans(updatedPlans);
  };

  const handleAddTopUp = (planIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].selectedTopUps.push("");
    updatedPlans[planIndex].topUpDropdownOpenList.push(false);
    updatedPlans[planIndex].topUpPrices.push("");
    setPlans(updatedPlans);
  };

  const handleTopUpSelect = (planIndex, topUpIndex, limit) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].selectedTopUps[topUpIndex] = limit;
    updatedPlans[planIndex].topUpDropdownOpenList[topUpIndex] = false;
    setPlans(updatedPlans);

    // Validate the type
    validateTopUpType(planIndex, topUpIndex, limit);

    // Validate the price if it exists
    const price = updatedPlans[planIndex].topUpPrices[topUpIndex];
    if (price) {
      validateTopUpPrice(planIndex, topUpIndex, price);
    }
  };

  const handleTopUpPriceChange = (planIndex, topUpIndex, value) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].topUpPrices[topUpIndex] = value;
    setPlans(updatedPlans);

    const topUpType = updatedPlans[planIndex].selectedTopUps[topUpIndex];
    validateTopUpType(planIndex, topUpIndex, topUpType);

    if (topUpType && topUpType.trim() !== "") {
      validateTopUpPrice(planIndex, topUpIndex, value);
    }
  };

  const handleAddFeature = (planIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].licenseFeature.push({ feature: "" });
    setPlans(updatedPlans);
  };

  const handleFeatureChange = (planIndex, featureIndex, value) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].licenseFeature[featureIndex].feature = value;
    setPlans(updatedPlans);
  };

  const handleSlabInputChange = (planIndex, slabIndex, field, value) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex].slabInputs[slabIndex][field] = value;
    setPlans(updatedPlans);
  };

  // const handleAddSlab = (planIndex) => {
  //   const updatedPlans = [...plans];
  //   updatedPlans[planIndex].slabInputs.push({
  //     periodCount: "",
  //     productCount: "",
  //     percentage: "",
  //   });
  //   setPlans(updatedPlans);
  // };

  const makeEmptyPlan = () => ({
    planName: "",
    plandescription: "",
    limitCounts: licenseLimits.map((limit) => ({ [limit]: "" })),
    licenseFeature: [{ feature: "" }],
    addedDurations: [{ duration: "", price: "" }],
    selectedDuration: "",
    selectedTopUps: [""],
    topUpPrices: [""],
    slabInputs: [{ periodCount: "", productCount: "", percentage: "" }],
    selectedSlabPeriod: "",
    slabPercentage: "",
    slabCount: "",
    slabPeriodCount: "",
    isSlabAvailableForAll: false,
    validationErrors: {},
    durationDropdownOpenList: [false],
    topUpDropdownOpenList: [false],
  });

  const handleRemovePlan = (planIndex) => {
    if (plans.length <= 1) {
      setPlans([makeEmptyPlan()]);
      return;
    }
    setPlans((prev) => prev.filter((_, idx) => idx !== planIndex));
  };

  const handleRemoveFeature = (planIndex, featureIndex) => {
    const updatedPlans = [...plans];
    if (updatedPlans[planIndex].licenseFeature.length <= 1) {
      updatedPlans[planIndex].licenseFeature[featureIndex].feature = "";
    } else {
      updatedPlans[planIndex].licenseFeature.splice(featureIndex, 1);
    }
    setPlans(updatedPlans);
  };

  const handleRemoveDuration = (planIndex, durationIndex) => {
    const updatedPlans = [...plans];
    const plan = updatedPlans[planIndex];

    if (plan.addedDurations.length <= 1) {
      // Keep at least one row; just clear it instead of removing
      plan.addedDurations[0] = { duration: "", price: "" };
      plan.durationDropdownOpenList[0] = false;
    } else {
      plan.addedDurations.splice(durationIndex, 1);
      // keep dropdown tracking array in sync
      plan.durationDropdownOpenList.splice(durationIndex, 1);
    }

    setPlans(updatedPlans);
  };

  const handleRemoveTopUp = (planIndex, topUpIndex) => {
    const updatedPlans = [...plans];
    const plan = updatedPlans[planIndex];

    if (plan.selectedTopUps.length <= 1) {
      plan.selectedTopUps[0] = "";
      plan.topUpPrices[0] = "";
      plan.topUpDropdownOpenList[0] = false;
    } else {
      plan.selectedTopUps.splice(topUpIndex, 1);
      plan.topUpPrices.splice(topUpIndex, 1);
      plan.topUpDropdownOpenList.splice(topUpIndex, 1);
    }

    setPlans(updatedPlans);
  };

  return (
    <div>
      <div className="flex justify-between items-center font-semibold text-sm bg-[#CEC7FF4D] my-5 py-2 px-4 rounded">
        <span>Plan Details</span>
        {/* <img src={refreshLogo} alt="" className="bg-white p-1 rounded-md" /> */}
      </div>

      <div className="w-full flex flex-col gap-4 text-sm">
        <div className="w-full flex gap-5">
          <div className="w-2/3 sm:w-1/2 relative" ref={dropdownRef}>
            <label className="text-sm blacktext font-medium">
              Application Name<span className="text-red-500">*</span>
            </label>
            <div
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="pl-3 mt-1 h-10 pr-4  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter bg-right bg-no-repeat focus:outline-none appearance-none flex items-center justify-between cursor-pointer"
              style={{
                backgroundImage: `url(${Expand_down})`,
                backgroundPosition: "98% center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <span
                className={`${
                  selectedProjectName === "" ? "text-[#9CA3AF]" : ""
                }`}
              >
                {selectedProjectName || "Select Application Name"}
              </span>
            </div>

            {dropdownOpen && (
              <div
                className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto pr-4"
                onScroll={(e) => {
                  const { scrollTop, scrollHeight, clientHeight } =
                    e.currentTarget;
                  if (scrollTop + clientHeight >= scrollHeight - 10) {
                    fetchProjectTypes(projectPage);
                  }
                }}
              >
                {projects.length === 0 ? (
                  <div className="px-4 py-2 text-sm text-gray-500">
                    No projects found
                  </div>
                ) : (
                  projects.map((project, idx) => (
                    <div
                      key={idx}
                      onClick={() => handleProjectTypeChange(project.name)}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                    >
                      {project.name}
                    </div>
                  ))
                )}
                {isLoadingProjects && (
                  <div className="px-4 py-2 text-sm text-gray-400">
                    Loading more...
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        {plans.map((plan, planIndex) => (
          <div
            key={planIndex}
            className="w-full flex flex-col  border-1 rounded-md flex gap-2 p-5 "
            style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
          >
            <div className="w-full flex justify-between items-center gap-3">
              {plans.length > 1 && planIndex > 0 && (
                <div className="flex w-full justify-between items-center font-semibold text-sm bg-[#CEC7FF4D] py-2 px-4 rounded">
                  <span>Plan Details</span>
                  {/* <img src={refreshLogo} alt="" className="bg-white p-1 rounded-md" /> */}
                </div>
              )}

              {/* <h1 className="text-2xl font-semibold mb-2">Create Plan</h1> */}

              {plans.length > 1 && planIndex > 0 && (
                <button
                  type="button"
                  onClick={() => handleRemovePlan(planIndex)}
                  className=" w-7 h-7 flex items-center justify-center
               rounded-full bg-[#9061DB] text-white text-sm font-bold
               border border-[#9061DB] transition
               hover:bg-white hover:text-[#9061DB] focus:outline-none focus:ring-2 focus:ring-[#9061DB]/40"
                  aria-label="Remove plan"
                  title="Remove plan"
                >
                  ✕
                </button>
              )}
            </div>

            <div className="flex flex-col">
              {" "}
              <label className="text-sm blacktext font-medium">
                Plan Name<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className=" pl-3 h-10 pr-4 mt-1 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                placeholder="Plan Name"
                value={plan.planName}
                onChange={(e) => {
                  const updatedPlans = [...plans];
                  updatedPlans[planIndex].planName = e.target.value;
                  setPlans(updatedPlans);
                }}
              />
            </div>

            <div className="flex flex-col">
              <label className="text-sm blacktext font-medium">
                Plan Description<span className="text-red-500">*</span>
              </label>
              <textarea
                placeholder="Plan Description"
                value={plan.plandescription}
                onChange={(e) => {
                  const updatedPlans = [...plans];
                  updatedPlans[planIndex].plandescription = e.target.value;
                  setPlans(updatedPlans);
                }}
                className="w-full pl-3 pt-2 h-16 pr-4  border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none "
              ></textarea>
            </div>

            {licenseLimits.length > 0 && (
              <h2 className="text-lg font-semibold my-2">Limit Details</h2>
            )}

            <div className="grid grid-cols-2   justify-between gap-4">
              {licenseLimits.map((limit, limitIndex) => (
                <div key={limitIndex} className="flex gap-4 ">
                  <span className="w-1/2 bg-[#F1EFFF]  px-3 rounded h-10 flex justify-start items-center">
                    {limit}
                  </span>
                  <div className="flex flex-col w-1/2">
                    <input
                      type="number"
                      className="w-full pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                      placeholder={`Add ${limit} Count`}
                      value={plan.limitCounts[limit] || ""}
                      onChange={(e) =>
                        handleCountChange(planIndex, limit, e.target.value)
                      }
                    />
                    {plan.validationErrors[limit] && (
                      <span className="text-red-500 text-xs mt-1">
                        {plan.validationErrors[limit]}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <h2 className="text-lg font-semibold my-2">Plan Feature</h2>

            <div className="flex flex-col">
              <label className="text-sm blacktext font-medium">
                Feature<span className="text-red-500">*</span>
              </label>{" "}
              <div className="w-full grid grid-cols-2 gap-4">
                {plan.licenseFeature.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex flex-col relative">
                    <input
                      type="text"
                      className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent  rounded-md font-inter focus:outline-none"
                      placeholder="Feature"
                      value={feature.feature}
                      onChange={(e) =>
                        handleFeatureChange(
                          planIndex,
                          featureIndex,
                          e.target.value
                        )
                      }
                    />

                    {plan.licenseFeature.length > 1 && featureIndex > 0 && (
                      <button
                        type="button"
                        onClick={() =>
                          handleRemoveFeature(planIndex, featureIndex)
                        }
                        className="w-7 h-7 absolute top-1 right-1  text-gray-400 font-bold"
                        title="Remove Feature"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                ))}

                <div
                  className="group flex justify-start items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2 col-span-2
                  hover:scale-105 transition-transform duration-300 hover:text-white text-primary hover:bg-primary"
                  style={{ willChange: "transform" }}
                  onClick={() => handleAddFeature(planIndex)}
                >
                  <img
                    src={Add_round}
                    alt=""
                    className="block group-hover:hidden"
                  />
                  <img
                    src={Add_roundWhite}
                    alt=""
                    className="group-hover:block hidden"
                  />
                  <span className="">Add Feature</span>
                </div>
              </div>
            </div>

            <h2 className="text-lg font-semibold my-2">Set Duration</h2>
            <div className="flex flex-col gap-4">
              {plan.addedDurations.map((durationItem, durationIndex) => (
                <div
                  key={durationIndex}
                  className="relative flex flex-col gap-4"
                >
                  <div className="flex gap-4 items-center">
                    {/* Duration Column */}
                    <div className="relative w-2/3 sm:w-1/2">
                      {/* Show label only for first row */}
                      {durationIndex === 0 && (
                        <label className="text-sm font-medium blacktext mb-1 block">
                          Duration<span className="text-red-500">*</span>
                        </label>
                      )}
                      <div
                        onClick={() =>
                          toggleDurationDropdown(planIndex, durationIndex)
                        }
                        className="pl-3 h-10 pr-10 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter flex items-center justify-between cursor-pointer"
                        style={{
                          backgroundImage: `url(${Expand_down})`,
                          backgroundPosition: "98% center",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <span
                          className={
                            durationItem.duration?.name
                              ? "text-black"
                              : "text-[#9CA3AF]"
                          }
                        >
                          {durationItem.duration?.name || "Select Duration"}
                        </span>
                      </div>

                      {plan.durationDropdownOpenList[durationIndex] && (
                        <div className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto">
                          {durations.length === 0 ? (
                            <div className="px-4 py-2 text-sm text-gray-500">
                              No durations found
                            </div>
                          ) : (
                            durations.map((duration) => (
                              <div
                                key={duration.id}
                                onClick={() =>
                                  handleDurationSelect(
                                    planIndex,
                                    durationIndex,
                                    duration
                                  )
                                }
                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                              >
                                {duration.name}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    {/* Price Column */}
                    <div className="flex flex-col w-1/3 sm:flex-grow">
                      {durationIndex === 0 && (
                        <label className="text-sm font-medium blacktext mb-1 block">
                          Price<span className="text-red-500">*</span>
                        </label>
                      )}
                      <input
                        type="number"
                        className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                        placeholder="Price"
                        value={durationItem.price}
                        onChange={(e) =>
                          handlePriceChange(
                            planIndex,
                            durationIndex,
                            e.target.value
                          )
                        }
                      />
                    </div>

                    {/* Remove button */}
                    {plan.addedDurations.length > 1 && durationIndex > 0 && (
                      <button
                        type="button"
                        onClick={() =>
                          handleRemoveDuration(planIndex, durationIndex)
                        }
                        className="w-7 h-7 flex items-center justify-center text-gray-400 text-sm font-bold"
                        title="Remove Duration"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
              ))}

              {/* Add Duration button */}
              <div
                className="flex justify-start items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2 mt-4
                hover:bg-primary hover:scale-105 transition-transform duration-300 group hover:text-white text-primary"
                onClick={() => handleAddDuration(planIndex)}
                style={{ willChange: "transform" }}
              >
                <img
                  src={Add_round}
                  alt=""
                  className="block group-hover:hidden"
                />
                <img
                  src={Add_roundWhite}
                  alt=""
                  className="group-hover:block hidden"
                />
                <span className="">Add Duration</span>
              </div>
            </div>

            {selectedProjectName && (
              <>
                <h2 className="text-lg font-semibold my-2">Top-Up Details</h2>
                <div className="flex flex-col gap-2">
                  {plan.selectedTopUps.map((selected, topUpIndex) => (
                    <div
                      key={topUpIndex}
                      className="relative flex flex-col gap-4"
                    >
                      <div className="w-full flex items-center gap-5">
                        {/* Top-Up Type Column */}
                        <div className="relative w-2/3 sm:w-1/2">
                          {topUpIndex === 0 && (
                            <label className="text-sm font-medium blacktext mb-1 block">
                              Top-Up Type<span className="text-red-500">*</span>
                            </label>
                          )}
                          <div
                            className="h-10 cursor-pointer pl-3 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter flex items-center justify-between"
                            onClick={() => {
                              const updatedPlans = [...plans];
                              updatedPlans[planIndex].topUpDropdownOpenList[
                                topUpIndex
                              ] =
                                !updatedPlans[planIndex].topUpDropdownOpenList[
                                  topUpIndex
                                ];
                              setPlans(updatedPlans);
                            }}
                            style={{
                              backgroundImage: `url(${Expand_down})`,
                              backgroundPosition: "98% center",
                              backgroundRepeat: "no-repeat",
                            }}
                          >
                            <span
                              className={
                                selected === ""
                                  ? "text-[#9CA3AF]"
                                  : "text-black"
                              }
                            >
                              {selected || "Select Top-Up Type"}
                            </span>
                          </div>

                          {plan.topUpDropdownOpenList[topUpIndex] && (
                            <div className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto">
                              {licenseLimits.length === 0 ? (
                                <div className="px-4 py-2 text-sm text-gray-500">
                                  No Top-Up options available
                                </div>
                              ) : (
                                licenseLimits.map((limit, idx) => (
                                  <div
                                    key={idx}
                                    onClick={() =>
                                      handleTopUpSelect(
                                        planIndex,
                                        topUpIndex,
                                        limit
                                      )
                                    }
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                                  >
                                    {limit}
                                  </div>
                                ))
                              )}
                            </div>
                          )}
                        </div>

                        {/* Platform Selling Price Column */}
                        <div className="flex flex-col w-1/3 sm:flex-grow">
                          {topUpIndex === 0 && (
                            <label className="text-sm font-medium blacktext mb-1 block">
                              Top-Up Price
                              <span className="text-red-500">*</span>
                            </label>
                          )}
                          <input
                            type="number"
                            className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                            placeholder="Top-Up Price"
                            value={plan.topUpPrices[topUpIndex] || ""}
                            onChange={(e) =>
                              handleTopUpPriceChange(
                                planIndex,
                                topUpIndex,
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {/* Remove Button */}
                        {plan.selectedTopUps.length > 1 && topUpIndex > 0 && (
                          <button
                            type="button"
                            onClick={() =>
                              handleRemoveTopUp(planIndex, topUpIndex)
                            }
                            className="z-20 w-7 h-7 flex items-center justify-center text-gray-400 text-sm font-bold"
                            title="Remove Top-Up"
                            aria-label="Remove top-up"
                          >
                            ✕
                          </button>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Add Top-Up Button */}
                  <div
                    className="flex justify-start items-center w-32 cursor-pointer rounded-md py-2 bg-[#CEC7FF4D] px-2 mt-4
                    hover:bg-primary hover:text-white text-primary hover:scale-105 transition-transform duration-300 group"
                    onClick={() => handleAddTopUp(planIndex)}
                    style={{ willChange: "transform" }}
                  >
                    <img
                      src={Add_round}
                      alt=""
                      className="block group-hover:hidden"
                    />
                    <img
                      src={Add_roundWhite}
                      alt=""
                      className="hidden group-hover:block"
                    />
                    <span className="">Add Top-Up</span>
                  </div>
                </div>
              </>
            )}

            {paymentGateway && (
              <>
                <h2 className="text-lg font-semibold my-2">Slab Details</h2>
                <div className="flex flex-col gap-4">
                  {/* Slab Period Dropdown */}
                  <div className="w-1/2 relative">
                    <label className="text-sm font-medium blacktext mb-1 block">
                      Slab Period
                    </label>
                    <div
                      className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter flex items-center justify-between cursor-pointer"
                      onClick={() => {
                        const updatedPlans = [...plans];
                        updatedPlans[planIndex].slabPeriodDropdownOpen =
                          !updatedPlans[planIndex].slabPeriodDropdownOpen;
                        setPlans(updatedPlans);
                      }}
                      style={{
                        backgroundImage: `url(${Expand_down})`,
                        backgroundPosition: "98% center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <span
                        className={
                          plan.selectedSlabPeriod
                            ? "text-black"
                            : "text-[#9CA3AF]"
                        }
                      >
                        {plan.selectedSlabPeriod || "Select Slab Period"}
                      </span>
                    </div>

                    {plan.slabPeriodDropdownOpen && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-[#8C8C8C4D] rounded-md shadow-sm max-h-56 overflow-y-auto">
                        {slabPeriodChoices.length === 0 ? (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No slab periods available
                          </div>
                        ) : (
                          slabPeriodChoices.map((period, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                const updatedPlans = [...plans];
                                updatedPlans[planIndex].selectedSlabPeriod =
                                  period;
                                updatedPlans[
                                  planIndex
                                ].slabPeriodDropdownOpen = false;
                                setPlans(updatedPlans);
                              }}
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
                            >
                              {period}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>

                  {/* Available for All Plans Checkbox */}
                  <div className="flex items-center mt-4">
                    <input
                      type="checkbox"
                      id={`slabAvailableForAll-${planIndex}`}
                      checked={plan.isSlabAvailableForAll}
                      onChange={(e) => {
                        const updatedPlans = [...plans];
                        updatedPlans[planIndex].isSlabAvailableForAll =
                          e.target.checked;
                        setPlans(updatedPlans);
                      }}
                      className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                    />
                    <label
                      htmlFor={`slabAvailableForAll-${planIndex}`}
                      className="ml-2 block text-sm text-gray-700"
                    >
                      Available for all plans
                    </label>
                  </div>

                  {/* Slab Inputs */}
                  {plan.selectedSlabPeriod && (
                    <div className="space-y-4">
                      {plan.slabInputs.map((slab, slabIndex) => (
                        <div key={slabIndex} className="flex gap-4">
                          {/* Slab Percentage */}
                          <div className="flex flex-col w-1/3">
                            {slabIndex === 0 && (
                              <label className="text-sm font-medium blacktext mb-1 block">
                                Slab Percentage
                              </label>
                            )}
                            <input
                              type="number"
                              className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                              placeholder="Slab Percentage"
                              value={slab.percentage}
                              onChange={(e) =>
                                handleSlabInputChange(
                                  planIndex,
                                  slabIndex,
                                  "percentage",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          {/* Slab Count */}
                          <div className="flex flex-col w-1/3">
                            {slabIndex === 0 && (
                              <label className="text-sm font-medium blacktext mb-1 block">
                                Slab Count
                              </label>
                            )}
                            <input
                              type="number"
                              className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                              placeholder="Slab Count"
                              value={slab.productCount}
                              onChange={(e) =>
                                handleSlabInputChange(
                                  planIndex,
                                  slabIndex,
                                  "productCount",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          {/* Slab Period Count */}
                          <div className="flex flex-col w-1/3">
                            {slabIndex === 0 && (
                              <label className="text-sm font-medium blacktext mb-1 block">
                                Slab Period Count
                              </label>
                            )}
                            <input
                              type="number"
                              className="pl-3 h-10 pr-4 border-2 border-[#8C8C8C4D] bg-transparent rounded-md font-inter focus:outline-none"
                              placeholder="Slab Period Count"
                              value={slab.periodCount}
                              onChange={(e) =>
                                handleSlabInputChange(
                                  planIndex,
                                  slabIndex,
                                  "periodCount",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}

            {planIndex === plans.length - 1 && (
              <div>
                <button
                  className="px-6 rounded-md text-primary font-semibold py-2 my-3 float-right border border-1 border-primary
                  hover:scale-105 transition-transform duration-300 hover:bg-primary hover:text-white"
                  style={{ willChange: "transform" }}
                  onClick={handleAddPlan}
                >
                  Add Another Plan
                </button>
              </div>
            )}
          </div>
        ))}

        {/* Add this after the plans mapping */}
        <div className="w-full flex justify-center mt-8">
          <button
            className="bg-primary w-64 py-1 text-white font-semibold rounded-md text-lg
            hover:scale-105 transition-transform duration-300 "
            style={{ willChange: "transform" }}
            onClick={handleSaveAllPlans}
          >
            Save
          </button>
        </div>
      </div>

      <AnimatePresence>
        {showSuccessModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50">
                    <motion.div
                      className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50"
                      animate={{
                        rotate: [0, -10, 10, -10, 10, 0], // shake motion
                      }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                      }}
                    >
                      <svg
                        className="w-12 h-12 text-green-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">
                    Success!
                  </h3>
                  <p className="text-gray-600 mb-6">{apiMessage}</p>
                </div>
                <div className="px-6 pb-6">
                  <button
                    onClick={() => {
                      setShowSuccessModal(false);
                      navigate("/myApplication");
                    }}
                    className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-medium rounded-lg"
                  >
                    Continue
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showErrorModal && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 bg-black bg-opacity-50"
            />
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
              <motion.div
                initial={{ scale: 0.9, y: 20, opacity: 0 }}
                animate={{ scale: 1, y: 0, opacity: 1 }}
                exit={{ scale: 0.9, y: 20, opacity: 0 }}
                className="w-full max-w-md bg-white rounded-xl shadow-xl"
              >
                <div className="flex justify-center pt-8">
                  <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-50">
                    <motion.div
                      className="flex items-center justify-center w-20 h-20 rounded-full bg-green-50"
                      animate={{
                        rotate: [0, -10, 10, -10, 10, 0], // shake motion
                      }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                      }}
                    >
                      <svg
                        className="w-8 h-8 text-red-500"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path
                          strokeWidth={2}
                          strokeLinecap="round"
                          d="M12 8v4m0 4h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"
                        />
                      </svg>
                    </motion.div>
                  </div>
                </div>
                <div className="px-6 py-4 text-center">
                  <p className="text-gray-600 mb-6">{apiMessage}</p>
                </div>
                <div className="px-6 pb-6">
                  <button
                    onClick={() => setShowErrorModal(false)}
                    className="w-full py-3 px-4 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg"
                  >
                    Try Again
                  </button>
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateLicense;
